const directiveModules = import.meta.glob('./*.js', { eager: true })

function removerLastIndex(str) {
  return str.slice(2, -3)
}

// 批量全局注册自定义指令
// let directives = {}
// requireDirective.keys().map((file) => {
//   const name = removerLastIndex(file)
//   if (name !== 'index') {
//     directives = {
//       ...directives,
//       [name]: requireDirective(file).default,
//     }
//   }

//   return false
// })

export default {
  install(Vue) {
    //   Object.keys(directives).forEach((key) => {
    //     Vue.directive(key, directives[key])
    //   })

    Object.entries(directiveModules).forEach(([path, mod]) => {
      // 去掉前缀 './' 和后缀 '.js'，例如 './focus.js' -> 'focus'
      const name = path.replace(/^\.\/(.*)\.js$/, '$1')

      if (name !== 'index') {
        Vue.directive(name, mod.default)
      }
    })
  },
}
